(() => {
  if (window.mbHomeImagesReady) return;
  window.mbHomeImagesReady = true;
  function dayInBerlin(date) {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(date);
      const value = type => Number(parts.find(part => part.type === type).value);
      return Math.floor(Date.UTC(value('year'), value('month') - 1, value('day')) / 86400000);
    } catch (_) { return Math.floor(date.getTime() / 86400000); }
  }
  function init(scope) {
    const sections = Array.from(scope.querySelectorAll('[data-mbh-rotation]'));
    if (scope.matches && scope.matches('[data-mbh-rotation]')) sections.unshift(scope);
    const day = dayInBerlin(new Date());
    sections.forEach(section => {
      const mode = section.dataset.mbhRotation;
      const period = mode === 'daily' ? day : mode === 'weekly' ? Math.floor((day + 3) / 7) : 0;
      section.querySelectorAll('[data-mbh-images]').forEach(data => {
        const img = data.parentElement.querySelector('.mbh-world-image, .mbh-category-image');
        if (!img) return;
        let images;
        try { images = JSON.parse(data.textContent); } catch (_) { return; }
        if (!Array.isArray(images)) return;
        images = images.filter(image => image && typeof image.src === 'string' && image.src);
        if (!images.length) return;
        const selected = images[((period % images.length) + images.length) % images.length];
        if (img.getAttribute('src') === selected.src) return;
        const attrs = ['src', 'srcset', 'alt', 'width', 'height'];
        const original = Object.fromEntries(attrs.map(name => [name, img.getAttribute(name)]));
        img.addEventListener('error', () => {
          attrs.forEach(name => {
            if (original[name] === null) img.removeAttribute(name);
            else img.setAttribute(name, original[name]);
          });
        }, { once: true });
        if (selected.srcset) img.setAttribute('srcset', selected.srcset);
        else img.removeAttribute('srcset');
        img.setAttribute('alt', selected.alt || '');
        if (selected.width > 0) img.setAttribute('width', selected.width);
        if (selected.height > 0) img.setAttribute('height', selected.height);
        img.setAttribute('src', selected.src);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
